import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Story from "@/components/Story";
import FeaturedProducts from "@/components/FeaturedProducts";
import Collections from "@/components/Collections";
import WhyNovaLand from "@/components/WhyNovaLand";
import SocialFeed from "@/components/SocialFeed";
import FAQ from "@/components/FAQ";
import PaymentInfo from "@/components/PaymentInfo";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Home = () => (
  <main data-testid="home-page">
    <Navbar />
    <Hero />
    <FeaturedProducts />
    <About />
    <Story />
    <Collections />
    <WhyNovaLand />
    <SocialFeed />
    <FAQ />
    <PaymentInfo />
    <Contact />
    <Footer />
    <WhatsAppFloat />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
